import {
  MenuItem,
  Select,
  Box,
  FormControl,
  InputLabel,
  Button,
  Chip,
} from "@mui/material";
import React, { useState } from "react";
import { useFetchRuleFields } from "hooks/useRuleConfigProcess";
import StyledDataGrid from "styles/styledDataGrid";

function RuleSetFieldSelection({
  inputSelected,
  outputSelected,
  setoutputSelected,
  setinputSelected,
}) {
  const [fieldList] = useFetchRuleFields();
  const deleteInputSelection = (index) => {
    setinputSelected(inputSelected.filter((f, i) => i !== index));
  };
  const deleteOutputSelection = (index) => {
    setoutputSelected(outputSelected.filter((f, i) => i !== index));
  };
  const [inputSelection, setinputSelection] = useState("");
  const [outputSelection, setoutputSelection] = useState("");

  const handleInputChange = (e) => {
    setinputSelection(
      fieldList.find((f) => f.ruleConfigFieldKey === e.target.value)
    );
  };
  const handleOutputChange = (e) => {
    setoutputSelection(
      fieldList.find((f) => f.ruleConfigFieldKey === e.target.value)
    );
  };
  const addInput = () => {
    setinputSelected([...inputSelected, inputSelection]);
    setinputSelection("");
  };
  const addOutput = () => {
    setoutputSelected([...outputSelected, outputSelection]);
    setoutputSelection("");
  };

  // Define columns for the DataGrid
  const columns = [
    {
      field: "input",
      headerName: "Input",
      flex: 1,
      renderCell: () => (
        <div>
          {inputSelected.map((f, i) => (
            <Chip
              sx={{ margin: 1 }}
              label={f.ruleConfigFieldName}
              key={f.ruleConfigFieldName}
              variant="outlined"
              onDelete={() => deleteInputSelection(i)}
            />
          ))}
        </div>
      ),
    },
    {
      field: "output",
      headerName: "Output",
      flex: 1,
      renderCell: () => (
        <div>
          {outputSelected.map((f, i) => (
            <Chip
              sx={{ margin: 1 }}
              label={f.ruleConfigFieldName}
              key={f.ruleConfigFieldName}
              variant="outlined"
              onDelete={() => deleteOutputSelection(i)}
            />
          ))}
        </div>
      ),
    },
  ];

  // One row for displaying our chip selections.
  const rows = [{ id: 1, input: inputSelected, output: outputSelected }];

  return (
    <div>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={(theme) => ({ display: "flex", margin: theme.spacing(1) })}>
          <FormControl sx={{ width: "300px" }}>
            <InputLabel htmlFor="input-select">Input Field</InputLabel>
            <Select
              sx={{ m: 1 }}
              label="Input Field"
              id={"input-select"}
              value={
                inputSelection?.ruleConfigFieldKey === undefined
                  ? ""
                  : inputSelection.ruleConfigFieldKey
              }
              onChange={handleInputChange}
            >
              {fieldList.map((f) => (
                <MenuItem
                  key={f.ruleConfigFieldKey}
                  value={f.ruleConfigFieldKey}
                >
                  {f.ruleConfigFieldName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button onClick={addInput} disabled={!inputSelection}>
            Add Input
          </Button>
        </Box>

        <Box sx={{ display: "flex" }} margin={1}>
          <FormControl sx={{ width: "300px" }}>
            <InputLabel htmlFor="output-select">Output Field</InputLabel>
            <Select
              sx={{ m: 1 }}
              label="Output Field"
              id={"output-select"}
              value={
                outputSelection?.ruleConfigFieldKey === undefined
                  ? ""
                  : outputSelection.ruleConfigFieldKey
              }
              onChange={handleOutputChange}
            >
              {fieldList.map((f) => (
                <MenuItem
                  key={f.ruleConfigFieldKey}
                  value={f.ruleConfigFieldKey}
                >
                  {f.ruleConfigFieldName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button onClick={addOutput} disabled={!outputSelection}>
            Add Output
          </Button>
        </Box>
      </Box>

      <Box sx={{ width: "100%", marginTop: 2 }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          hideFooter
          disableColumnMenu
          disableSelectionOnClick
        />
      </Box>
    </div>
  );
}

export default RuleSetFieldSelection;
